import React, { useState } from "react";
import { Popconfirm, Input, message, Button, Space } from "antd";
import Service, { ElAdminEventLogService } from "../../services";
import { TRADE_STATUS } from "../../utils";

const SetLeverageForAllButton = ({ accounts }) => {
  const [targetLeverage, setTargetLeverage] = useState(null);

  const updateLeverageForAll = async () => {
    for (const account of accounts) {
      if (!account.permissions || !account.permissions.includes("CONTROL")) {
        message.error("You don't have the permission to set leverages");
        return;
      }
      if (account.status === TRADE_STATUS.trading) {
        try {
          const setLeverageResult = await Service.setLeverage({
            exchangeInstrument: account.exchange,
            account: account.account,
            pair: account.symbol,
            leverage: targetLeverage,
            sessionName: account.sessionName,
          });
          await ElAdminEventLogService.saveSetLeverageEvent(targetLeverage, account);
          message.success(`${setLeverageResult}. This change should be picked up by the system within 1 min.`, 5);
        } catch (error) {
          message.error(error.message ? error.message : String(error));
        }
      }
    }
  };

  return (
    <Space>
      <Popconfirm
        title={
          <>
            <div style={{ marginBottom: 8 }}>
              Set Leverage for All
              <br />
              Active Trading Sessions
            </div>
            <Input
              style={{ marginLeft: -15 }}
              type="number"
              value={targetLeverage}
              onChange={(e) => setTargetLeverage(e.target.value)}
              max="10"
              min="1"
              placeholder="Enter leverage"
            />
          </>
        }
        onConfirm={updateLeverageForAll}
        okText="Confirm"
        cancelText="Cancel"
      >
        <Button>Set All Leverage</Button>
      </Popconfirm>
    </Space>
  );
};

export default SetLeverageForAllButton;
